import { CreateWalrProjectCommand } from "app/ApiClient";
import * as Yup from "yup";


export const initialValues: CreateWalrProjectCommand = {
  datasetId: "",
  datasetName: "",
  projectId: "",
};

export const validationSchema = Yup.object<CreateWalrProjectCommand>({
    projectId: Yup.string().required(),
    datasetId: Yup.string().required(),
    datasetName: Yup.string().required()
});
